export const OptimizationParameters = () => (
  <>
    <h3>Optimization parameters</h3>
    <h4>Absolute sensitivity / ftol</h4>
    <p>
      <p>
        Default: <strong>1e-6</strong> (0.0001%)<br></br>
      </p>
      A higher value of absolute sensitivity corresponds to a lower value of ftol.
      If the probability for all fatty acids change less than ftol inbetween optimization steps, the optimization algorithm stops.
      A higher sensitivity leads to longer computation time, but a too low sensitivity leads to a premature termination of the optimization.
    </p>

    <h4>Relative sensitivity / gtol</h4>
    <p>
      <p>
        Default: <strong>1e-4</strong> (0.01%)<br></br>
      </p>
      A higher value of relative sensitivity corresponds to a lower value of gtol.
      If the change in probability for all fatty acids changes less than gtol inbetween optimization steps, the optimization algorithm stops.
      A higher sensitivity leads to longer computation time, but a too low sensitivity leads to a premature termination of the optimization.
    </p>
    
    <h4>Maximal optimization steps</h4>
    <p>
      <p>
        Default: <strong>200</strong><br></br>
      </p>
      If the absolute and relative change is lower than the machine precision, the algorithm may stop before reaching the maximum optimization steps, even if gtol and ftol have been set to zero.
    </p>

    <h4>Start fatty acid profile</h4>
    <h5>Guess start profile</h5>
    <p>
      <p>
        Default behavior: <strong>True</strong><br></br>
        Alternatively, all fatty acid probabilities are given the same value at the start of optimization.
      </p>
      A fatty acid profile is guessed from the target lipid profile.
      <ol>
        <li>initialize an empty fatty acid profile with all probabilities as zero</li>
        <li>for each lipid species with <em>n</em> fatty acids, split the lipid species into <em>n</em> parts for the sum of carbons and double bonds each</li>
        <li>all products of carbon and double bond parts gets the probability of the lipid species added</li>
        <li>drop all fatty acids not considered in the optimization and normalize profile</li>
      </ol>
      To split either sum of carbons or double bonds into <em>n</em> parts:
      <ol>
        <li>compute the <em>quotient</em> and <em>remainder</em> of the number of carbons or double bonds and <em>n</em></li>
        <li>take <em>n - remainder</em> times the <em>quotient</em>, and <em>remainder</em> times the <em>quotient + 1</em></li>
      </ol>
    </p>
    <h5>Prefer even chained fatty acids</h5>
    <p>
      <p>
        Default behavior: <strong>True</strong><br></br>
        Alternatively, use the default algorithm to split the sum of carbons (<em>cc</em>) into <em>n</em> parts.
      </p>
      The sum of carbons is split in a way to favor even parts instead.
      <ol>
        <li>compute the <em>quotient</em> and <em>remainder</em> of <em>cc</em> and <em>n</em></li>
        <li>calculate the next lower/higher even numbers (<em>lower</em>/<em>higher</em>) by subtracting/adding the remainder of <em>quotient</em> and 2 from/to the <em>quotient</em></li>
        <li>
          if the <em>remainder</em> is not zero take <em>lower</em> and the result of the algorithm for <em>cc - lower</em> and <em>n - 1</em>
        </li>
        <li>else, we have to split up uneven <em>cc</em> into one lower and one higher even number.
          <ol>
            <li>Compute how many uneven numbers we can split up into two numbers (<em>half</em>) and how many are left (<em>leftover</em>) by taking the quotient and remainder of <em>n</em> and 2, respectively</li>
            <li>Take <em>half</em> times <em>lower</em>, <em>half</em> times <em>higher</em> and <em>leftover</em> times <em>quotient</em></li>
          </ol>
        </li>
      </ol>
    </p>
  </>
)
